import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SalesTrendsGridConfigService } from 'src/app/data-grid/sales-trends-grid-config.service';
import { AvailableWeeks } from '../date-picker-dialog/date-picker.model';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-date-dialog',
  templateUrl: './date-dialog.component.html',
  styleUrls: ['./date-dialog.component.scss']
})
export class DateDialogComponent implements OnInit,OnDestroy {
  dateForm: FormGroup = new FormGroup({
    selectDate: new FormControl("weekly"),
  })
  date = new Date();
  spin: boolean = false;
  months: any []= [];
  currentMonth = new Date().getMonth();
  day: any = [{ name: "This week" }, { name: "Last week" }, { name: "2 weeks ago" }, { name: "3 weeks ago" }, { name: "4 weeks ago" }];
  monthLabel: any = []
  selectedMonth: any = [];
  selectedQuarterLabel: any = [];
  selectedWeekLabel: any = [];
  currentYear: number = new Date().getFullYear();
  quartely = this.salesTrendGridConfigService.quartely;
  selectedWeek = this.salesTrendGridConfigService.selectedWeek;
  selectedWeeklyDate: any = [];
  year = this.date.getFullYear();
  selectedDate = this.salesTrendGridConfigService.selectedType;
  month:any = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
  currentDate:any
  startDate:any;
  endDate:any
  selectQuaterly = [];
  isDisable: boolean = true;
  private destroy$ = new Subject<void>();

  constructor(public dialogRef: MatDialogRef<DateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private salesTrendGridConfigService: SalesTrendsGridConfigService) { }

  ngOnInit(): void {
    this.setMonth();
    this.setQuarterly();
    if(this.dialogData?.data){
      this.selectedDate = this.dialogData.data.selectd;
    }
    this.dateForm.controls["selectDate"]?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) {
        this.selectedDate = res;
        this.getIsDisable();
        this.bindCheckBoxValue();
      }
    })
    this.dateForm.controls["selectDate"].setValue(this.selectedDate)
    this.bindCheckBoxValue();
  }

  selectMonth(event, selectedMonth) {
    this.months.filter((res) => {
      if (event.checked && res.name === selectedMonth.name) res.checked = true;
      else if (!event.checked && res.name === selectedMonth.name) res.checked = false;
    });
    this.getIsDisable();
  }

  selectDay(event?, selectedDay?) {
    this.day.filter((res) => {
      if (event.checked && res.name === selectedDay.name) res.checked = true;
      else if (!event.checked && res.name === selectedDay.name) res.checked = false;
    });
    this.getIsDisable();
  }

  selectQuartely(event, selectQuartely) {
    this.quartely.filter((res) => {
      if (event.checked && res.months === selectQuartely.months) res.checked = true;
      else if (!event.checked && res.months === selectQuartely.months) res.checked = false;
    });
    this.getIsDisable();
  }

  save() {
    this.spin = true;
    if (this.selectedDate == 'weekly') {
      this.setAllWeeklyDate();
    } else if (this.selectedDate == 'monthly') {
      this.setAllMonthlyDate();
    } else
      this.selectQuartelyDate();
  }

  setAllWeeklyDate() {
    this.day.forEach((res) => {
        if (res.checked) {
            const index = this.selectedWeeklyDate.length + 1;
            this.getLabelWeeklyDate(res.name, index);
        }
    });
}

  getDaysAgo(amountOfDays: number): number {
    return amountOfDays * 24 * 60 * 60 * 1000;
  }
  getLabelWeeklyDate(label: AvailableWeeks, index: number): any {
    this.selectedWeek.forEach((el: any, i: any) => {
        if (el.label === label) {
            const weeklyDate = {
                [`dateFrom${index}`]: new Date(el.from.setHours(0, 0, 0, 0) - (el.to.getTimezoneOffset() * 60000)).toISOString(),
            }
            this.selectedWeeklyDate.push(weeklyDate);
            this.selectedWeekLabel.push(label);
        }
    })
    if(this.dialogData.callBackFn){
        this.dialogData.callBackFn(this.dialogRef,{ allSelectedDate: this.selectedWeeklyDate, selectd: "weekly", label: this.selectedWeekLabel,selectedLabel:'Weekly' },this.spin);
    }
  }

  setAllMonthlyDate() {
    this.months.forEach((res: any, i: any) => {
      if (res.checked) {
        const index = this.selectedWeeklyDate.length + 1;
        let monthNumber = parseInt(res.monthNumber); 
        this.getMonthlyDate(monthNumber, res.year,res.name,index)
    }
    })
  }
  getMonthlyDate(month,year,monthName,index) {
    let date: any = {};
    date = {
      [`dateFrom${index}`]: new Date(new Date(year, month, 1).setHours(0, 0, 0, 0) - (new Date(year, month + 1, 0).getTimezoneOffset() * 60000)),
    }
    this.monthLabel.push(monthName);
    this.selectedWeeklyDate.push(date);
    this.selectedMonth.push(month);
    if (this.selectedWeeklyDate.length === this.months.filter(res => res.checked).length) {
      if( this.dialogData.callBackFn){
        this.dialogData.callBackFn(this.dialogRef,{ allSelectedDate: this.selectedWeeklyDate, selectd: "monthly", label: this.monthLabel, selectedMonth: this.selectedMonth,selectedLabel:'Monthly' },this.spin);
        }
    }
  }

  selectQuartelyDate() {
    this.quartely.forEach((res, i: any) => {
      if (res.checked) {
        const index = this.selectedWeeklyDate.length + 1;
        this.getQuartelyDate(res.months, index);
      }
    })
  }

  getQuartelyDate(name,index) {
    this.selectQuaterly.forEach((el: any, i: any) => {
      if (el.label === name) {
        const quaterly = {
          [`dateFrom${index}`]: new Date(el.from.setHours(0, 0, 0, 0) - (el.to.getTimezoneOffset() * 60000)).toISOString(),
        }
        this.selectedQuarterLabel.push(name);
        this.selectedWeeklyDate.push(quaterly);
      }
    })
    if(  this.dialogData.callBackFn){
      this.dialogData.callBackFn(this.dialogRef,{ allSelectedDate: this.selectedWeeklyDate, selectd: "quarterly", label: this.selectedQuarterLabel,selectedLabel:'Quarterly' },this.spin);
    }
  }
  reset() {
    this.dateForm.controls["selectDate"].setValue("weekly");
    this.day.forEach((res) => {
      res.checked = true;
    })
    this.dialogRef.close('reset');
  }

  bindCheckBoxValue() {
    if (this.selectedDate === "quarterly") {
      if (this.dialogData.data) {
        this.dialogData.data.label.forEach((res) => {
          this.quartely.forEach((ele) => res == ele.months ? ele.checked = true : null);
          this.day.forEach((ele) => ele.checked = false);
          this.months.forEach((ele) => ele.checked = false);
        })
      }
      else this.quartely.forEach((ele) => ele.checked = true)
    } else if (this.selectedDate === "monthly") {
      if (this.dialogData?.data) {
        this.dialogData?.data?.selectedMonth.forEach((res) => {
          this.months.forEach((ele) => res == ele.monthNumber ? ele.checked = true : null);
          this.quartely.forEach((ele) => ele.checked = false);
          this.day.forEach((ele) => ele.checked = false);
        })
      }
      else
        this.months.forEach((ele) => ele.checked = true)
    }
    else if (this.selectedDate === "weekly") {
      if (this.dialogData?.data) {
        this.dialogData?.data?.label.forEach((res) => {
          this.day.forEach((ele) => res == ele.name ? ele.checked = true : null);
          this.quartely.forEach((ele) => ele.checked = false);
          this.months.forEach((ele) => ele.checked = false);
        })
      } else
        this.day.forEach((ele) => ele.checked = true)
    }
    this.getIsDisable(); 
  }

  setMonth(){
    let monthName:any = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
     var date = new Date();
     date.setDate(1);
       for ( let i:any=0; i<5; i++) {
        this.months.push({name: monthName[date.getMonth()], monthNumber: date.getMonth(),year: date.getFullYear()});
        date.setMonth(date.getMonth() - 1);
     }
  }

  setQuarterly() {
    this.quartely = [];
    this.selectQuaterly = [];
    let monthName = new Date().getMonth();
    let lastMonth;
    let lastYear;
    let currentDate = new Date();
    for (let i = 0; i < 4; i++) {
      this.startDate = new Date(this.date.setMonth(this.date.getMonth() - 3));
      this.currentYear = this.date.getFullYear();
      this.currentMonth = this.date.getMonth();
      if (i > 0) {
        this.year = null;
        monthName = null;
        currentDate = null;
      }
      let label = this.month[this.currentMonth] + " " + this.currentYear + ' ' + (this.month[monthName] ? this.month[monthName] : this.month[lastMonth]) + " " + (this.year ? this.year : lastYear)
      this.selectQuaterly.push(
        {
          label: label,
          from: currentDate ? currentDate : this.endDate,
          to: this.startDate,
        },
      )
      this.quartely.push({
        value: "quarter" + i,
        months: label
      })
      lastYear = this.currentYear;
      lastMonth = this.currentMonth;
      this.endDate = this.startDate;
    }
  }

  getIsDisable(){
    if(this.selectedDate=='weekly'){
      this.isDisable = !this.day.some(day => day.checked); 
    } else if(this.selectedDate=='monthly'){
      this.isDisable = !this.months.some(month => month.checked);
    } else if(this.selectedDate=='quarterly'){
      this.isDisable = !this.quartely.some(quarter => quarter.checked);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
